import { Star } from 'lucide-react';

type RatingSize = 'small' | 'medium' | 'large';

interface RatingProps {
  size?: RatingSize;
  value?: number;
  readOnly?: boolean;
  onChange?: (value: number) => void;
  precision?: number;
}

const sizeClasses: Record<RatingSize, string> = {
  small: 'w-4 h-4',
  medium: 'w-6 h-6',
  large: 'w-8 h-8'
};

export function Rating({
  size = 'small',
  value = 0,
  readOnly = true,
  onChange
}: RatingProps) {
  // Ensure value is never negative and is within 0-5 range
  const clampedValue = Math.max(0, Math.min(5, value || 0));

  return (
    <div className='flex gap-0 items-center'>
      {[1, 2, 3, 4, 5].map(star => (
        <button
          key={star}
          type='button'
          className={`${sizeClasses[size]} disabled:cursor-default`}
          disabled={readOnly}
          onClick={() => onChange?.(star)}
        >
          <Star
            className={`w-full h-full ${
              star <= clampedValue
                ? 'fill-[#E4BF50] stroke-[#E4BF50]'
                : 'fill-[#D9D9D9] stroke-[#D9D9D9]'
            }`}
          />
        </button>
      ))}
    </div>
  );
}
